import React from "react";
import ReactApexChart from "react-apexcharts";
import "../CompanyNameChart/CompanyNameChart.css";

const CompanyNameChart = () => {
  // Updated data for Empty, Mismatched, and Perfect Companies
  const series = [50, 20, 70]; // Values for Empty, Mismatched, and Perfect Companies
  const options = {
    chart: {
      //   height: 390,
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: "30%",
      
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
        barLabels: {
          enabled: true,
          useSeriesColors: false,
          offsetX: -14,
          fontSize: "16px", // Updated font size
          color: "#999",
          formatter: function (seriesName, opts) {
            return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
          },
        },
      },
    },
    colors: ["#404dad", "#6e7ad4", "#efc58a"], // Updated with your specific colors
    labels: ["Empty Company", "Mismatched Company", "Perfect Company"], // Updated labels
    tooltip: {
      enabled: true,
      style: {
        fontSize: "16px", // Updated font size
        color: "#999"
      },
      formatter: function (val, { seriesIndex }) {
        const label = options.labels[seriesIndex];
        return `${label}: ${val}%`;
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            show: false,
            labels: {
              style: {
                fontSize: "16px", // Updated font size for legend
              },
            },
          },
        },
      },
    ],
  };

  return (
    <>
      <section className="full-section">
        <div className="full-company-container">
          <div className="full-company-header">
            <h1>
              Proportional Analysis of Company Name Categories: Empty,
              Mismatched, and Perfect <sub style={{color: "blue"}}>(Radial Bar Chart)</sub>
            </h1>
          </div>

          <div className="full-company-parent">
            <div className="full-company-chart-container">
              <ReactApexChart
                options={options}
                series={series}
                type="radialBar"
                height={420}
                width="100%"
              />
            </div>
            <div className="full-company-legend-table">
              <table>
                <thead>
                  <tr className="full-thead">
                    <td>Legend</td>
                    <td>Name</td>
                    <td>Count</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#404dad" }}
                      ></i>
                    </td>
                    <td>Empty Company</td>
                    <td>People :</td>
                    <td>43732213</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#6e7ad4" }}
                      ></i>
                    </td>
                    <td>Mismatched Company</td>
                    <td>Count :</td>
                    <td>43732213</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#efc58a" }}
                      ></i>
                    </td>
                    <td>Perfect Company</td>
                    <td>Area :</td>
                    <td>43732213</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CompanyNameChart;
